const options = {
  5: "bg-fuchsia-600/5",
  10: "bg-fuchsia-600/10",
  25: "bg-fuchsia-600/25",
  50: "bg-fuchsia-600/50",
  75: "bg-fuchsia-600/75",
  90: "bg-fuchsia-600/90",
  100: "bg-fuchsia-600",
};

const from = {
  5: "from-fuchsia-600/5",
  10: "from-fuchsia-600/10",
  25: "from-fuchsia-600/25",
  50: "from-fuchsia-600/50",
  75: "from-fuchsia-600/75",
  90: "from-fuchsia-600/90",
  100: "from-fuchsia-600",
};

export default function getBackgroundFuchsia600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
